// extracted by mini-css-extract-plugin
module.exports = {"image":"BlogCard-module__image___wKs5U","list":"BlogCard-module__list___3NCuj"};